// extracted by css-extract-rspack-plugin
export default {"form":"PSgGbLqtNbkdcPX3","fields":"jAiOsytTpIkflhSL","rowMain":"GqoXb2i7CW8WU2Dz","rowSecondary":"hL4ufBVkfIgPydHp","fieldPeriod":"SSwkRwBEZfcCnSEh","buttons":"s0Y_rjXhkSUrGfVv"};